import { createGlobalStyle } from 'styled-components';

import ITCCharterNormalWoff from './fonts/CharterITCW05-Regular.woff';
import ITCCharterNormalWoff2 from './fonts/CharterITCW05-Regular.woff2';

import ITCCharterBoldWoff from './fonts/CharterITCW05-Bold.woff';
import ITCCharterBoldWoff2 from './fonts/CharterITCW05-Bold.woff2';

import ITCCharterItalicWoff from './fonts/CharterITCW05-Italic.woff';
import ITCCharterItalicWoff2 from './fonts/CharterITCW05-Italic.woff2';

import ITCCharterBoldItalicWoff from './fonts/CharterITCW05-BoldItalic.woff';
import ITCCharterBoldItalicWoff2 from './fonts/CharterITCW05-BoldItalic.woff2';

import PWCHelveticalNormalWoff from './fonts/pwc-helvetica-neue-400.woff';
import PWCHelveticalNormalWoff2 from './fonts/pwc-helvetica-neue-400.woff2';

import PWCHelveticalBoldWoff from './fonts/pwc-helvetica-neue-bold-500.woff';
import PWCHelveticalBoldWoff2 from './fonts/pwc-helvetica-neue-bold-500.woff2';

export const SANS_SERIF = 'PwC Helvetica Neue, Helvetica, Arial';
export const SERIF = 'PwC ITC Charter, Georgia, serif';

const Webfonts = createGlobalStyle`
  /* PWC ITC Charter */
  @font-face {
    display: swap;
    font-family: SERIF;
    font-style: normal;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    src: url(${ITCCharterNormalWoff2}) format('woff2'),
      url(${ITCCharterNormalWoff}) format('woff');
  }

  @font-face {
    display: swap;
    font-family: SERIF;
    font-style: italic;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    src: url(${ITCCharterItalicWoff}) format('woff2'),
      url(${ITCCharterItalicWoff2}) format('woff');
  }

  @font-face {
    display: swap;
    font-family: SERIF;
    font-style: normal;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    src: url(${ITCCharterBoldWoff}) format('woff2'),
      url(${ITCCharterBoldWoff2}) format('woff');
  }

    @font-face {
    display: swap;
    font-family: SERIF;
    font-style: italic;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    src: url(${ITCCharterBoldItalicWoff}) format('woff2'),
      url(${ITCCharterBoldItalicWoff2}) format('woff');
  }

  /* PWC Helvetica Neue */
  @font-face {
    display: swap;
    font-family: SANS-SERIF;
    font-style: normal;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    src: url(${PWCHelveticalNormalWoff2}) format('woff2'),
      url(${PWCHelveticalNormalWoff}) format('woff');
  }

  @font-face {
    display: swap;
    font-family: SANS-SERIF;
    font-style: normal;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    src: url(${PWCHelveticalBoldWoff2}) format('woff2'),
      url(${PWCHelveticalBoldWoff}) format('woff');
  }
`;

export default Webfonts;
